import { Client } from 'src/api/Client';
import {
  AdminSubscriptionBrandResponse,
  SyncSubscriptionBrandsRequest,
} from './AdminSubscriptionBrandClient.types';

class AdminSubscriptionBrandClient extends Client {
  public readonly route = {
    sync: `${this.http.baseUrl}/admin/subscriptions/{subscriptionId}/brands`,
    attach: `${this.http.baseUrl}/admin/subscriptions/{subscriptionId}/brands/{brandId}`,
    detach: `${this.http.baseUrl}/admin/subscriptions/{subscriptionId}/brands/{brandId}`,
  };

  sync = (
    subscriptionId: string,
    data: SyncSubscriptionBrandsRequest,
  ): Promise<AdminSubscriptionBrandResponse> =>
    this.http.put(this.buildUrl(this.route.sync, { subscriptionId }), data);

  attach = (
    subscriptionId: string,
    brandId: string,
  ): Promise<AdminSubscriptionBrandResponse> =>
    this.http.post(this.buildUrl(this.route.attach, { subscriptionId, brandId }));

  detach = (
    subscriptionId: string,
    brandId: string,
  ): Promise<AdminSubscriptionBrandResponse> =>
    this.http.delete(this.buildUrl(this.route.detach, { subscriptionId, brandId }));
}

export { AdminSubscriptionBrandClient };
